import React from "react";
import ReactEcharts from "echarts-for-react";

export const mockData = [
  {
    name: "Rainfall",
    values: [
      { x: "Jan", y: 2.0 },
      { x: "Feb", y: 4.9 },
      { x: "Mar", y: 7.0 },
      { x: "Apr", y: 23.2 },
      { x: "May", y: 25.6 },
      { x: "Jun", y: 76.7 },
      { x: "Jul", y: 135.6 },
      { x: "Aug", y: 162.2 },
      { x: "Sep", y: 32.6 },
      { x: "Oct", y: 20.0 },
      { x: "Nov", y: 6.4 },
      { x: "Dec", y: 3.3 },
    ],
  },
  {
    name: "Evaporation",
    values: [
      { x: "Jan", y: 2.6 },
      { x: "Feb", y: 5.9 },
      { x: "Mar", y: 9.0 },
      { x: "Apr", y: 26.4 },
      { x: "May", y: 28.7 },
      { x: "Jun", y: 70.7 },
      { x: "Jul", y: 175.6 },
      { x: "Aug", y: 182.2 },
      { x: "Sep", y: 48.7 },
      { x: "Oct", y: 18.8 },
      { x: "Nov", y: 6.0 },
      { x: "Dec", y: 2.3 },
    ],
  },
];

type BarCompareChartProps = {
  data: { name: string; values: { x: string; y: number }[] }[];
  title: string;
  yAxisName: string;
  height: string;
  target: number;
};
const mappingMonth: any = {
  jan: "ม.ค.",
  feb: "ก.พ.",
  mar: "มี.ค.",
  apr: "เม.ย.",
  may: "พ.ค.",
  jun: "มิ.ย.",
  jul: "ก.ค.",
  aug: "ส.ค.",
  sep: "ก.ย.",
  oct: "ต.ค.",
  nov: "พ.ย.",
  dec: "ธ.ค.",
};

export const BarCompareChart: React.FC<BarCompareChartProps> = ({
  data,
  title,
  yAxisName,
  height,
  target,
}) => {
  const options = {
    title: {
      text: title,
    },
    tooltip: {
      trigger: "axis",
    },
    // legend: {
    //     data: Object.keys(data)
    // },
    toolbox: {
      show: true,
      feature: {
        // dataView: { show: true, readOnly: false },
        // magicType: { show: true, type: ['line', 'bar'] },
        // restore: { show: true },
        // saveAsImage: { show: true }
      },
    },
    calculable: true,
    xAxis: [
      {
        type: "category",
        data: data[0]?.values.map((item) =>
          mappingMonth.hasOwnProperty(item.x) ? mappingMonth[item.x] : item.x
        ),
      },
    ],
    yAxis: {
      type: "value",
      offset: -8,
      name: yAxisName, // yAxis name prop
      splitLine: {
        lineStyle: {
          color: "lightgrey",
        },
      },
    },
    series: [
      ...data.map((dataset, index) => ({
        name: dataset.name,
        type: "bar",
        data: dataset.values.map((item) => item.y),
        // markLine: {
        //     data: [{ type: 'average', name: 'Avg' }]
        // }
        itemStyle: {
          color: index === 0 ? "#00A4C3" : index === 1 ? "#6DB64F" : "red", // Apply color based on index
          borderRadius: [8, 8, 0, 0], // Rounded corners for a rounded bar only for index 1
        },
        // label: {
        //     show: true,
        //     position: 'top'
        // },
      })),
      {
        name: "Target",
        type: "line",
        data: data[0]?.values.map(() => target),
        lineStyle: {
          color: "orange",
          width: 2,
          type: "dashed",
        },
        symbol: "none",
      },
    ],
  };
  return (
    <ReactEcharts option={options} style={{ height: height, width: "100%" }} />
  );
};
